import type { ColumnDef } from '@ovComponents/2-component/dataTable';

export function getPhantomColumns<TData>(
  options: { withExpand?: boolean } = {},
): ColumnDef<TData, unknown>[] {
  const columns: ColumnDef<TData, unknown>[] = [
    { id: 'select', header: '', enableSorting: false },
  ];
  if (options.withExpand) {
    columns.push({ id: 'expand', header: '', enableSorting: false });
  }
  return columns;
}
